<ng-template #seeProductList let-modal>
  <p class="mb-4 p-2 w-100" style="font-size: 1.4rem; font-weight: bold; text-align: center"><i
      class="fa-solid fa-handshake"></i> Similar Products</p>

  <div class="prods p-4">
    <ng-container *ngFor="let list of searchProds">
      <common-product-card-view [postalCode]="postalCode" (view)="goToProduct($event)" [list]="list"
        [isCommunityProduct]="true">
      </common-product-card-view>
    </ng-container>
  </div>
  <p *ngIf="searchProds.length < 1" class="p-3" style="text-align: center; color: var(--primary)"><i
      class="fas fa-heart-broken"></i> No products found for your search</p>
</ng-template>

<ng-template #editCategory let-modal>
  <div class="modal-header">
    <h1 class="modal-title">Edit Category</h1>
    <div class="d-flex align-items-center">
      <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
    </div>
  </div>
  <div class="modal-body">

    <div class="form-group" *ngIf="isSubregionCombination">
      <label for="">Category Edit Mode</label>
      <select class="form-control" [(ngModel)]="categoryEditMode" (change)="categoryEditModeChange($event)">
        <option *ngFor="let sub of bottomSubregions" [value]="sub.slug">{{ sub.name }}</option>
      </select>
    </div>
    <!-- Event Image -->
    <h2>Event Image</h2>
    <img loading="lazy" *ngIf="imageBase64 && !isSubregionCombination"
      class="map-search-listing-img mt-2 product-char-image w-100" [src]="imageBase64" alt="" />
    <img loading="lazy" *ngIf="subCategory?.image && !isSubregionCombination"
      class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + subCategory?.image" />

    <button class="com_btn px-1 month-list-add-more mt-3" (click)="upload.click()" *ngIf="!isSubregionCombination"><i
        class="fas fa-plus"></i> Upload Event Image</button>
    <input type="file" #upload (change)="saveProductCharSelectedImage($event)" class="suggestion-modal-pic-input d-none"
      accept="image/*" />
    <!-- End Event Image -->

    <!-- Banner Image -->
    <h2>Banner Image</h2>
    <img loading="lazy" *ngIf="imageBase64Banner && !isSubregionCombination"
      class="map-search-listing-img mt-2 product-char-image w-100" [src]="imageBase64Banner" alt="" />
    <img loading="lazy" *ngIf="subCategory?.bannerImage && !isSubregionCombination"
      class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + subCategory?.bannerImage" />

    <button class="com_btn px-1 month-list-add-more mt-3" (click)="uploadBanner.click()"
      *ngIf="!isSubregionCombination"><i class="fas fa-plus"></i> Upload Banner Image</button>
    <input type="file" #uploadBanner (change)="saveProductCharSelectedImage($event, true)"
      class="suggestion-modal-pic-input d-none" accept="image/*" />
    <!-- End Banner Image -->

    <!-- Promo Banner Image -->
    <h2>Promo Banner Image</h2>
    <img loading="lazy" *ngIf="encodedPromoFile && !isSubregionCombination"
      class="map-search-listing-img mt-2 product-char-image w-100" [src]="encodedPromoFile" alt="" />
    <img loading="lazy" *ngIf="subCategory?.promoBannerImage && !isSubregionCombination"
      class="map-search-listing-img mt-2 product-char-image w-100" [src]="imgUrl + subCategory?.promoBannerImage" />

    <button class="com_btn px-1 month-list-add-more mt-3" (click)="uploadPromoImage.click()"
      *ngIf="!isSubregionCombination"><i class="fas fa-plus"></i> Upload Promo Image</button>
    <input type="file" #uploadPromoImage style="visibility: hidden" id="upload-promo-image"
      (change)="promoBannerChange($event)" class="suggestion-modal-pic-input d-none" accept="image/*" />

    <!-- End Promo Banner Image -->

    <div class="row" *ngIf="!isSubregionCombination">
      <div class="form-group col-12">
        <h2>Redirect URL</h2>
        <input type="text" placeholder="Redirect URL" [(ngModel)]="promoRedirectURL" class="form-control" />
      </div>
    </div>

    <div class="row" *ngIf="isSubregionCombination">
      <div class="col-6">
        <button class="com_btn px-1 month-list-add-more mt-3 w-100" (click)="paginateRegion(false)">
          <i class="fas fa-chevron-left"></i> Previous Sub Region
        </button>
      </div>
      <div class="col-6">
        <button class="com_btn px-1 month-list-add-more mt-3 w-100" (click)="paginateRegion(true)">
          Next Sub Region <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>

    <ul class="nav nav-tabs mt-3">
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ active: formMenu == 'main' }" (click)="formMenu = 'main'">Main</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" [ngClass]="{ active: formMenu == 'meta' }" (click)="formMenu = 'meta'">Meta</a>
      </li>
      <li class="nav-item" *ngIf="!isSubregionCombination">
        <a class="nav-link" [ngClass]="{ active: formMenu == 'faq' }" (click)="formMenu = 'faq'">FAQ</a>
      </li>
    </ul>

    <ng-container *ngIf="formMenu == 'main'">
      <div class="row" *ngIf="!isSubregionCombination">
        <div class="form-group col-12">
          <h2>Category Name</h2>
          <input type="text" [(ngModel)]="categoryName" class="form-control" placeholder="Enter Category Name" />
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <h2>Bottom Text</h2>
          <textarea id="bottomText" [(ngModel)]="currentBottomText" cols="30" rows="30" class="form-control"
            style="min-height: 600px;" placeholder="Enter Bottom Text(HTML)"></textarea>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="formMenu == 'meta'">
      <div class="row">
        <div class="form-group col-12">
          <h2>Meta Config</h2>
          <textarea readonly [(ngModel)]="domMeta" cols="30" rows="10" class="form-control" style="min-height: 300px;"
            placeholder="Enter Meta Config"></textarea>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="formMenu == 'meta'">
      <div class="row">
        <div class="form-group col-12">
          <h2>Schema Code</h2>
          <textarea  readonly [(ngModel)]="domSchema" cols="30" rows="10" class="form-control" style="min-height: 300px;"
            placeholder="Enter Schema Code"></textarea>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="formMenu == 'faq' && !isSubregionCombination">
      <!------------------------------------------------------------------------------------------>
      <div class="row">
        <div class="form-group col-12">
          <h2>Question One</h2>
          <textarea [(ngModel)]="questionOne" placeholder="Question" cols="30" rows="1" class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <h3>Answer One</h3>
          <textarea [(ngModel)]="answerOne" placeholder="Answer One" cols="30" rows="5" class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <h2>Question Two</h2>
          <textarea [(ngModel)]="questionTwo" placeholder="Question" cols="30" rows="1" class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <h3>Answer Two</h3>
          <textarea [(ngModel)]="answerTwo" placeholder="Answer Two" cols="30" rows="5" class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <h2>Question Three</h2>
          <textarea [(ngModel)]="questionThree" placeholder="Question" cols="30" rows="1"
            class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <h3>Answer Three</h3>
          <textarea [(ngModel)]="anserThree" placeholder="Answer Three" cols="30" rows="5"
            class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <h2>Question Four</h2>
          <textarea [(ngModel)]="questionFour" placeholder="Question" cols="30" rows="1"
            class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <h3>Answer Four</h3>
          <textarea [(ngModel)]="anserFour" placeholder="Answer Four" cols="30" rows="5"
            class="form-control"></textarea>
        </div>
      </div>

      <!---------------------------------------------------------------------------------------------->

      <div class="row">
        <div class="form-group col-12">
          <h2>Question Five</h2>
          <textarea [(ngModel)]="questionFive" placeholder="Question" cols="30" rows="1"
            class="form-control"></textarea>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-12">
          <h3>Answer Five</h3>
          <textarea [(ngModel)]="anserFive" placeholder="Answer Five" cols="30" rows="5"
            class="form-control"></textarea>
        </div>
      </div>
    </ng-container>

    <duv class="d-flex justify-content-end">
      <button type="button" class="btn btn-secondary" (click)="editCategorySubmit()">Save</button>
    </duv>
  </div>
</ng-template>

<!------------------------------------------------------------------------------------------------------>
<div class="search-page">
  <div class="container" style="max-width: 1440px">
    <app-breadcrumb *ngIf="breadCrumbData" [data]="breadCrumbData"></app-breadcrumb>

    <div class="rounded header-wrapper w-100 d-flex justify-content-start align-items-center flex-column"
      style="width: fit-content; position: relative">
      <div class="back-button-section w-100" style="position: static;">
        <button class="back-button" (click)="goBack()"><i class="fa fa-arrow-left" aria-hidden="true"></i> Back</button>
      </div>
      <div class="position-relative d-flex flex-column align-items-center justify-content-end">
        <img lass="d-none" (load)="topImageLoad($event)" *ngIf="currentCategoryBG" [src]="imgUrl + currentCategoryBG"
          style="background-repeat: no-repeat" class="rounded" />

      </div>

      <ng-template #catTitle>
        <div class="d-flex flex-column">
          <div class="d-flex flex-wrap w-100 mb-1" *ngIf="typeList?.length">
            <button *ngFor="let type of typeList" class="btn btn-sm btn-outline-primary ml-2"
              (click)="searchSimilarSubType(type)">{{type.name}}</button>
          </div>
          <div class="d-flex justify-content-between">
            <div>
              <div class="title postion-relative" style="width: 100%" [class.cat-name]="currentCategoryBG"
                *ngIf="!isLoading">
                <ng-container *ngIf="isSubregionCombination"> Best </ng-container>
                <ng-container *ngIf="isTypeInfoLoaded">
                  {{currentTypeName}} 
                </ng-container>
                {{ currentCategoryName }}
                <ng-container *ngIf="isSubregionCombination">in {{ currentSubRegionName }}</ng-container>
              </div>
              <div *ngIf="isSubregionCombination && !(totalMemberShopProductList?.length == 0 && !isLoading)"
                class="mt-2">
                <span class="sub-title">Choose from {{ totalMemberShopProductList.length }} {{ currentCategoryName }} in
                  {{
                  currentSubRegionName }} </span>
              </div>
            </div>
            <div class="form-group mt-auto">
              <input type="text" class="form-control" placeholder="Postal Code" maxlength="6"
                (keyup)="handlePostalCodeChange($event)">
            </div>
          </div>
          <button *ngIf="isUserAnAdmin" class="btn btn-sm btn-outline-primary mt-2"
            [class.mb-3]="totalMemberShopProductList?.length == 0 && !isLoading"
            style="top: 0; left: 100%; width: 10rem" (click)="openEditCategoryModal()">
            <i class="fa fa-ellipsis-v mr-2"></i>
            Edit Category
          </button>
        </div>
      </ng-template>
      <div class="header">
        <!-- <div [innerHTML]="subCategory?.codeSchema">
    </div> -->
        <!-- <script type="application/ld+json" *ngIf="subCategory?.codeSchema">
      {{subCategory?.codeSchema}}
    </script> -->
      </div>
      <router-outlet></router-outlet>

      <!-- Sub category -->
      <section class="row mx-1 mt-4" *ngIf="subCategoryList && subCategoryList.length > 0">
        <div class="col-2 sub-category" [routerLink]="'/category/' + i.slug" *ngFor="let i of subCategoryList">
          {{ i?.categoryName }}
        </div>
      </section>
      <!-- Sub category -->

      <div class="hidden-mobile h-100 w-100">
        <div class="grid-wrapper">
          <div>
            <app-product-types-list [showAllTypes]="true" [editable]="false" *ngIf="isInitDone" [showViaPopup]="false" (selectedType)="setCurrentType($event)"
              (typeList)="typeList = $event" [categoryId]="subCategory?.id"
              [class.d-none]="(!typesExist || !isInitDone) && !isUserAnAdmin"
              (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()"></app-product-types-list>
          </div>

          <!-- Product List -->
          <div class="d-flex flex-column" *ngIf="totalMemberShopProductList?.length">
            <div *ngTemplateOutlet="catTitle"></div>
            <div class="products mb-2 w-100">
              <common-product-card-view [postalCode]="postalCode" (view)="viewProductDetails($event)"
                [isSelected]="i < 5" [canBeSelected]="isSelectProductsToCompareOn" (selected)="productSelectedChanged(list, $event)"
                *ngFor="let list of totalMemberShopProductList; let i = index" [list]="list" [isCommunityProduct]="true"
                [toSinglePage]="true"></common-product-card-view>
            </div>
            <div class="show-more" (click)="getProductList()">
              <div *ngIf="currentPage < lastPage">Show more <i class="fa-solid fa-chevron-down"></i></div>
            </div>
          </div>

          <ng-container *ngIf="totalMemberShopProductList?.length == 0 && !isLoading">
            <div class="d-flex flex-column">
              <div *ngTemplateOutlet="catTitle"></div>
            </div>

          </ng-container>
          <div class="d-flex flex-column" style="gap: 1em">
            <button class="btn m-1 mb-2 search-btn" *ngIf="productsToCompare?.length"
                (click)="isSelectProductsToCompareOn ? openCompareProductsModal() :  turnComparisonOn()"><i class="fa-solid fa-code-compare"></i>{{isSelectProductsToCompareOn ?  '  Compare Products' : '  Select  To Compare'}}  </button>
            
            <button class="btn search-btn" (click)="isSelectProductsToCompareOn = false" *ngIf="isSelectProductsToCompareOn"><i class="fa fa-x"></i> Cancel Comparison</button>
            <app-product-faq-list [categoryId]="subCategory?.id"
              (faqsExist)="faqsExist = $event"></app-product-faq-list>
          </div>
        </div>
      </div>
      <div class="hidden-desktop h-100 w-100">
        <app-my-carousel-swiper class="product-mobile-swiper" [config]="carOptions">
          <div class="swiper-slide" *ngIf="typesExist || !isInitDone">
            <app-product-types-list [showAllTypes]="true" [editable]="false" *ngIf="isInitDone" [showViaPopup]="false" (selectedType)="setCurrentType($event)"
              (typeList)="typeList = $event" [categoryId]="subCategory?.id"
              (typesExist)="typesExist = $event; realignSwiperIndexWhenTabsChange()"></app-product-types-list>
          </div>

          <div class="swiper-slide">
            <ng-container *ngIf="totalMemberShopProductList?.length != 0">
              <div *ngTemplateOutlet="catTitle"></div>
            </ng-container>

            <div class="d-flex flex-column justify-content-center">
              <div class="products mb-2 w-100">
                <common-product-card-view [postalCode]="postalCode" (view)="viewProductDetails($event)"
                  [isSelected]="i < 5" [canBeSelected]="isSelectProductsToCompareOn" (selected)="productSelectedChanged(list, $event)"
                  *ngFor="let list of totalMemberShopProductList; let i = index" [list]="list"
                  [isCommunityProduct]="true" [toSinglePage]="true"></common-product-card-view>
              </div>
              <div class="show-more" (click)="getProductList()">
                <div *ngIf="currentPage < lastPage">Show more <i class="fa-solid fa-chevron-down"></i></div>
              </div>
            </div>

            <ng-container *ngIf="totalMemberShopProductList?.length == 0">
              <div class="d-flex flex-column">
                <div *ngTemplateOutlet="catTitle" class="mb-2"></div>
                <div
                  style="display: flex; justify-content: center; flex-direction: column; align-items: center; height: 200px; font-size: 1.5rem; border: dotted 3px #59288040">
                  <p><i class="fa fa-exclamation-circle" aria-hidden="true"></i> No Item found</p>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="swiper-slide">
            <div class="d-flex flex-column">
              <button class="btn m-1 mb-2 search-btn" *ngIf="productsToCompare?.length"
              (click)="isSelectProductsToCompareOn ? openCompareProductsModal() :  turnComparisonOn()"><i class="fa-solid fa-code-compare"></i>{{isSelectProductsToCompareOn ?  '  Compare Products' : '  Select To Compare'}}  </button>
          
          <button class="btn search-btn" (click)="isSelectProductsToCompareOn = false" *ngIf="isSelectProductsToCompareOn"><i class="fa fa-x"></i> Cancel Comparison</button>
              <app-product-faq-list [categoryId]="subCategory?.id"
                (faqsExist)="faqsExist = $event"></app-product-faq-list>
            </div>
          </div>
        </app-my-carousel-swiper>
      </div>
      <div>
        <button class="btn btn-secondary w-100 mb-2 d-block d-md-none mt-3" (click)="showMap = !showMap">
          <i [ngClass]="showMap ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
          {{ showMap ? "Hide Map" : "Show Map" }}
        </button>
      </div>
      <div class="mt-2 map container" [class.d-none]="totalMemberShopProductList?.length == 0 || !showMap" id="map">
      </div>

      <ng-container *ngIf="bottomText && bottomText != 'undefiend' && bottomText != 'null'">
        <div class="mt-2 m-4 bottom-text" style="text-align: left; color: var(--primary); font-size: 1.5rem"
          [innerHTML]="bottomText"></div>
      </ng-container>

      <div class="d-flex justify-content-start bottom-btns">

        <div>
          <ng-container *ngIf="subCategory.relationCategories?.length > 0">
            <div class="header my-2" style="grid-column: span 4">
              <div class="title">Other Categories</div>
            </div>

            <div class="list">
              <span class="mr-2 mt-2" *ngFor="let sub of subCategory.relationCategories">
                <button class="my-button-3" [routerLink]="'/category/' + sub.slug">
                  {{ sub.name }}
                </button>
              </span>
            </div>
          </ng-container>

          <div class="header my-2" style="grid-column: span 4">
            <div class="title">Nearby {{ subCategory?.name }}</div>
          </div>

          <div class="list">
            <span class="mr-2 mt-2" *ngFor="let region of bottomSubregions">
              <button class="my-button-3" (click)="setRegion(region)">{{ subCategory?.name }} in {{ region?.name
                }}</button>
            </span>
          </div>


        </div>

      </div>
    </div>
  </div>
  <app-marketplace #marketplace [share]="true"></app-marketplace>
</div>